import {
  DataTable,
  DataTableProps,
} from "../../../components/common/data-table/DataTable";
import Loading from "../../../components/Loading";
import { ColumnInterface } from "../../../interfaces/customTableInterface";
import { TProductPriceHistory } from "../../../features/productPriceHistories";
import { getFullDateFormat } from "../../../utils/dateFormater";

type ProductPriceHistoryTableProps = {
  data: TProductPriceHistory[];
  isLoading: boolean;
} & Pick<DataTableProps<TProductPriceHistory>, "pagination" | "extraActions">;

const columns: ColumnInterface<TProductPriceHistory>[] = [
  {
    key: "price",
    label: "Precio",
  },
  {
    key: "cost",
    label: "Costo",
  },
  {
    key: "effectiveFrom",
    label: "Fecha de inicio",
  },
  {
    key: "effectiveTo",
    label: "Fecha de termino",
  },
  {
    key: "createdBy",
    label: "Creado por",
  },
  {
    key: "createdAt",
    label: "Fecha de creación",
  },
  {
    key: "updatedBy",
    label: "Editado por",
  },
  {
    key: "updatedAt",
    label: "Fecha ultima edición",
  },
  {
    key: "active",
    label: "Estado",
  },
];

export const ProductPriceHistoryTable = (
  props: ProductPriceHistoryTableProps,
) => {
  const { isLoading, ...rest } = props;

  if (isLoading) return <Loading />;
  return (
    <DataTable
      columns={columns}
      tableId="product-price-history-table"
      customRender={(key, item) => {
        if (
          key === "effectiveFrom" ||
          key === "effectiveTo" ||
          key === "createdAt" ||
          key === "updatedAt"
        ) {
          if (!item[key]) return null;
          return getFullDateFormat(item[key] as Date);
        }
        if (key === "createdBy") {
          return item.userCreated
            ? `${item.userCreated.name} ${item.userCreated.lastName}`
            : "N/A";
        }
        if (key === "updatedBy") {
          return item.userUpdated
            ? `${item.userUpdated.name} ${item.userUpdated.lastName}`
            : "N/A";
        }
        if (key === "active") {
          return item.active ? "Activo" : "Inactivo";
        }
        return item[key] ?? "N/A";
      }}
      {...rest}
    />
  );
};
